import angular from 'angular';

import component from './carsScript.component';

export default angular.module('app.shared.carsScript', [
    /* your module dependencies go here */
])

.directive('carsScript', component)

.name;
